import { z } from 'my-zod'
import { enumOptionsToObject } from './enum-helpers'

export const ProgramNameEnum = z
  .enum([
    'PolarisAdventures',
    'FleetSaleOnly',
    'IndianMotorcycleRentals',
    'Marine',
    'EmployeePolarisOwnedUnits',
    'Marketing',
    'Engineering',
    'SalesDemo',
    'InternalCheckout',
    'Test'
  ])
  .setEnumLabels({
    PolarisAdventures: 'Polaris Adventures',
    FleetSaleOnly: 'Fleet Sale Only',
    IndianMotorcycleRentals: 'Indian Motorcycle Rentals',
    Marine: 'Marine',
    EmployeePolarisOwnedUnits: 'Employee Polaris Owned Units',
    Marketing: 'Marketing',
    Engineering: 'Engineering',
    SalesDemo: 'Sales Demo',
    InternalCheckout: 'Internal Checkout',
    Test: 'Test'
  })

export type ProgramNameEnum = z.infer<typeof ProgramNameEnum>
export const ProgramNameOptions = Object.values(ProgramNameEnum.Values)

export const outfitterProgramNameOptions = [
  'EmployeePolarisOwnedUnits',
  'Engineering',
  'FleetSaleOnly',
  'IndianMotorcycleRentals',
  'InternalCheckout',
  'Marine',
  'Marketing',
  'PolarisAdventures',
  'PolarisAdventuresElite',
  'SalesDemo',
  'Test',
  'TestElite'
] as const
export const outfitterProgramNames = enumOptionsToObject(outfitterProgramNameOptions)
export type OutfitterProgramName = (typeof outfitterProgramNameOptions)[number]
export const outfitterProgramNameLabels: Record<OutfitterProgramName, string> = {
  EmployeePolarisOwnedUnits: 'Employee Polaris Owned Units',
  Engineering: 'Engineering',
  FleetSaleOnly: 'Fleet Sale Only',
  IndianMotorcycleRentals: 'Indian Motorcycle Rentals',
  InternalCheckout: 'Internal Checkout',
  Marine: 'Marine',
  Marketing: 'Marketing',
  PolarisAdventures: 'Polaris Adventures',
  PolarisAdventuresElite: 'Polaris Adventures Elite',
  SalesDemo: 'Sales Demo',
  Test: 'Test',
  TestElite: 'Test Elite'
}

export const outfitterProgramNameEnum = z.enum(outfitterProgramNameOptions).setEnumLabels(outfitterProgramNameLabels)
